import React, { Component } from "react";
import axios from 'axios'; 
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import Serverurl from './Apiurl';
import IconButton from '@mui/material/IconButton';
import Drawer from '@mui/material/Drawer';
import AddLeadstatusbox from './Adminleadstatus';
import { Navigate } from 'react-router-dom';

export default class SlideNotification extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            right: false, 
            listadat: [], 
            ldmid: 0, 
            ldcuid: 0,
            popredirect: false, 
            pagename: ''
        };
        this.updateParentschedule = this.updateParentschedule.bind(this);
    }

    updateParentschedule = () => {
        this.Notificationapicall();
    }

    componentDidMount() {
        this.Notificationapicall();
    }

    Notificationapicall() {
        axios.get(Serverurl + 'ajaxleadmaster.php?action=leadsnotify')
            .then(resp => {
                // Always ensure listadat is an array
                const data = Array.isArray(resp.data) ? resp.data : [];
                this.setState({ listadat: data });
                
                // Always call parent callback with length
                this.props.parentleadCallback(data.length);
            })
            .catch(error => {
                console.error('Notification API Error:', error);
                // Ensure state remains an array even on error
                this.setState({ listadat: [] });
            })
            .finally(() => {
                // Restart polling after 14 minutes (840000ms)
                setTimeout(() => this.Notificationapicall(), 840000);
            });
    }

    handleFollowOpens = () => {
        this.setState({ right: !this.state.right });
    };

    onClickAccept = (stsid, isacept) => {
        let strmsg = "Accept";
        if (isacept === "2") {
            strmsg = "Reject";
        }
        let r = window.confirm("Do you really want to " + strmsg + "?");
        
        if (r === true) {
            var formData = new FormData();
            formData.append('action', 'acptnoshow');
            formData.append('st_id', stsid);
            formData.append('sts_acceptedby', localStorage.getItem("AYLuserid"));
            formData.append('sts_isaccept', isacept);

            axios.post(Serverurl + "ajaxstaffschedule.php", formData, {})
                .then(res => {
                    this.Notificationapicall();
                })
                .catch(error => {
                    console.error('Accept/Reject API Error:', error);
                });
        }
    }

    Leadstatusaddbox = (val, cuid) => {
        this.setState({ ldmid: val, ldcuid: cuid }, () => {
            // Check if ref exists before calling
            if (this.refs.AddLeadstatusbox) {
                this.refs.AddLeadstatusbox.handleLeadStatus();
            }
        });
    }

    LeadstoRenew = (val, type) => {
        if (type === "1") {
            this.setState({ popredirect: true, pagename: '/Adminbilling?orid=' + val });
        } else {
            this.setState({ popredirect: true, pagename: '/Adminbilling?ldid=' + val });
        }
    }

    render() {
        if (this.state.popredirect === true) {
            return <Navigate to={this.state.pagename} />;
        }

        // Defensive check - ensure listadat is always an array
        const notifications = Array.isArray(this.state.listadat) ? this.state.listadat : [];

        return (
            <React.Fragment>
                <AddLeadstatusbox 
                    ref="AddLeadstatusbox" 
                    cuid={this.state.ldcuid} 
                    id={this.state.ldmid} 
                    updateDonenew={this.updateParentschedule}
                />
                <Drawer 
                    anchor={'right'}
                    open={this.state.right}
                    onClose={this.handleFollowOpens}
                >
                    {notifications.length > 0 && (
                        <div className="leadsnots">
                            <h2>
                                <IconButton onClick={this.handleFollowOpens}>
                                    <ChevronLeftIcon />
                                </IconButton> 
                                Notifications
                            </h2>
                            <ul>
                                {notifications.map((no, index) => {
                                    return (
                                        <li key={no.id || index}>
                                            {no.type === "2" && (
                                                <React.Fragment>
                                                    {no.ldm_firstname} of {no.ldmtype} class. please accept
                                                    <div 
                                                        className="btngrren" 
                                                        onClick={() => this.onClickAccept(no.id, 1)}
                                                    >
                                                        Accept
                                                    </div>
                                                    <div 
                                                        className="btngrren" 
                                                        onClick={() => this.onClickAccept(no.id, 2)}
                                                    >
                                                        No Show
                                                    </div>
                                                </React.Fragment>
                                            )}
                                            {no.type === "1" && (
                                                <React.Fragment>
                                                    {no.ldm_firstname} is <span>{no.ldmtype}</span> lead. please contact  <b>{no.ldm_phoneno}</b>
                                                    <div 
                                                        className="btngrren" 
                                                        onClick={() => this.Leadstatusaddbox(no.id, 2)}
                                                    >
                                                        Status
                                                    </div>&nbsp;
                                                    {no.ldmtype === "In Active" && (
                                                        <div 
                                                            className="btngrren" 
                                                            onClick={() => this.LeadstoRenew(no.or_address, "1")}
                                                        >
                                                            Renew
                                                        </div>
                                                    )}
                                                    {no.ldmtype === "Enquiry" && (
                                                        <div 
                                                            className="btngrren" 
                                                            onClick={() => this.LeadstoRenew(no.id, "2")}
                                                        >
                                                            Subscribe
                                                        </div>
                                                    )}
                                                </React.Fragment>
                                            )}
                                            {no.type === "3" && (
                                                <React.Fragment>
                                                    {no.ldm_firstname} is applied for <span>{no.ldmtype}</span> leave on {no.editfollowupdate}. Reason: <b>{no.ldm_phoneno}</b>
                                                    <a href='/Approveleave'>
                                                        <div className="btngrren">Please click here to know more</div>
                                                    </a>
                                                </React.Fragment>
                                            )}
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    )}
                </Drawer>
            </React.Fragment>
        );
    }
}
